/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merry_Sunny_Antelope_EnrichInputs */

const fr_merry_sunny_antelope_enrich = /** @type {(inputs: Merry_Sunny_Antelope_EnrichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max (%)`)
};

/**

* @param {Merry_Sunny_Antelope_EnrichInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const merry_sunny_antelope_enrich = /** @type {((inputs?: Merry_Sunny_Antelope_EnrichInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merry_Sunny_Antelope_EnrichInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_merry_sunny_antelope_enrich(inputs)
});